export default "__VITE_ASSET__C3p04OrV__"